import { environment } from "src/environments/environment";
import * as helpers from '../helpers/ui-helpers';
import { DateTime } from "luxon";
import { BuildServices, GenericRouteEvent, RouteEventAction, RouteEventActionColorMap, RouteEventActionFillMap, RouteEventActionTypeMap } from "./normalize";
import { BaseJob } from "./job.type";
import { Capacitor } from "@capacitor/core";

export class AnyJobBase extends GenericRouteEvent {

  public value: BaseJob;
  public onTheWayCompleted = !environment.features.hasOnTheWay;
  public label: string;
  public riderName: string;

  constructor(value: BaseJob, services: BuildServices) {
    super(services);
    this.completed = !!value.departedTime;
    this.scheduledStart = value.scheduledTime ? DateTime.fromISO(value.scheduledTime.toString()) : null;
    this.scheduledEnd = this.scheduledStart && value.stopDuration
      ? this.scheduledStart.plus({ seconds: value.stopDuration })
      : null;

    this.headerInfo.time = helpers.getTimeForCardHeader({ start: this.scheduledStart, end: this.scheduledEnd, translateSvc: services.translateSvc });
    this.headerInfo.details = helpers.handleName(value.riderFirstName, value.riderLastName);
    this.headerInfo.timeTo = this.scheduledStart?.toRelative();

    this.completed = !!value.departedTime;
    this.location = value.location;
    this.stopSequence = value.sequence || 0;
    this.value = value;

    this.riderName =  value.riderLastName ? `${ value.riderLastName }, ${ value.riderFirstName }` : '';
    this.typeIcons = [ helpers.TypeIcons.waypoint ];
    this.id = value.rideId;
  }

  public getActions(): RouteEventAction[] {
    const actions: RouteEventAction[] =  [
      {
        type: RouteEventActionTypeMap.onTheWay,
        label: 'ACTION.onTheWay',
        show: helpers.canOnTheWayJob(this.value),
        icon: 'send',
        color: RouteEventActionColorMap.primary,
        fill: RouteEventActionFillMap.solid,
        preview: false,
        drivingMode: false,
        disabled: false,
        fn: (action: RouteEventAction) => this.onTheWay(action),
      },
      {
        type: RouteEventActionTypeMap.arrive,
        label: `${ this.translateSvc.translate('ACTION.arrive') } ${ this.translateSvc.translate(this.label) }`,
        show: helpers.canArrive(this.value),
        icon: 'locate', color: RouteEventActionColorMap.primary, fill: RouteEventActionFillMap.solid,
        preview: false,
        drivingMode: false,
        disabled: false,
        fn: (action: RouteEventAction) => this.arrive({ action }),
      },
      {
        type: RouteEventActionTypeMap.depart,
        label: `${ this.translateSvc.translate('ACTION.depart') } ${ this.translateSvc.translate(this.label) }`,
        show: this.onTheWayCompleted && this.value.arriveTime && this.value.performTime,
        icon: 'log-out', color: RouteEventActionColorMap.primary, fill: RouteEventActionFillMap.solid,
        preview: false,
        drivingMode: false,
        disabled: false,
        fn: (action: RouteEventAction) => this.depart({ action }),
      },
      {
        type: RouteEventActionTypeMap.navigate,
        label: `ACTION.navigate`,
        show: this.value.jobEnabled && helpers.hasValidGeo(this.location),
        icon: 'navigate',
        color: RouteEventActionColorMap.primary,
        fill: RouteEventActionFillMap.outline,
        preview: false,
        drivingMode: true,
        disabled: false,
        fn: async () => this.locationSvc.navigateToDestination(this.location.coordinate),
      },
      {
        type: RouteEventActionTypeMap.seeOn,
        label: `${ this.translateSvc.translate('LABEL.seeOn') } ${ this.translateSvc.translate('LABEL.map') }`,
        show: (this.appData.currentRouteIsPreview || Capacitor.getPlatform() !== 'ios') && helpers.hasValidGeo(this.location),
        icon: 'map', color: RouteEventActionColorMap.medium,
        fill: RouteEventActionFillMap.outline,
        preview: true,
        drivingMode: false,
        disabled: false,
        fn: async () => this.locationSvc.previewLocation(this.location.coordinate, this.location.name),
      },
    ].filter(action => action.show);
    return actions;
  }

  async perform(event: { action: RouteEventAction, noShow?: any }) {}

}
